export default __webpack_public_path__ + "static/media/rocket_anim_128.93d5d4bf.png";